export const API_LOGIN = "/users/login"
export const API_SELF = "/users/me"
export const API_GET_MEMBERS = "/members"
export const API_GET_MEMBER_STATUSES = "/members/statuses"
export const API_GET_SECTIONS = "/sections"
export const API_UPDATE_MEMBER = "/members"
export const API_ADD_MEMBER = "/members"
export const API_INVITE = "/users/invite"
